import { render, staticRenderFns } from "./CheckoutOverlaySeparator.vue?vue&type=template&id=bb12b3ba&scoped=true&"
import script from "./CheckoutOverlaySeparator.vue?vue&type=script&lang=js&"
export * from "./CheckoutOverlaySeparator.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutOverlaySeparator.vue?vue&type=style&index=0&id=bb12b3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb12b3ba",
  null
  
)

export default component.exports